// extracted by mini-css-extract-plugin
export default {"addressContainer":"styles_addressContainer__X1pun"};